import webservice from "./webserviceMainReducer"

const reducers = () => {
	return {
		webservice
	}
}
export default reducers;